<template>
    <div>
        <el-row :gutter="20" style="margin-bottom: 20px">
            <el-col :span="8" v-if="$isFullAdmin">
                &nbsp;
                <el-button type="primary" icon="el-icon-plus" @click="dialogVisible = true">{{$t('common.create')}}</el-button>
                <!-- <el-button icon="el-icon-download" @click="download" v-if="$isAdmin">{{$t('common.export')}}</el-button> -->
            </el-col>
            <el-col :span="4">
                <product-selector v-model="filter.productId"></product-selector>
            </el-col>
            <el-col :span="12">
                <el-input v-model="filter.text" prefix-icon="el-icon-search"></el-input>
            </el-col>
        </el-row>
        <el-table size="mini" :data="categories" v-loading="loading" class="orders-table tablewithshading">
            <el-table-column prop="name" :label="$t('common.name')" width="200"></el-table-column>
            <el-table-column prop="productName" :label="$t('common.product')" ></el-table-column>
            <el-table-column :label="$t('common.operations')" fixed="right" :width="$isSuperAdmin ? 160 : 116 + 'px'">
                <template slot-scope="scope">
                    <el-button size="mini" @click="editCategory(scope.row.id)">
                        <i class="el-icon-edit"></i>
                    </el-button>
                    <el-button size="mini" type="danger" @click="deleteCategory(scope.row.id)" v-if="$isFullAdmin && $isSuperAdmin">
                        <i class="el-icon-delete"></i>
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination class="pager" v-if="total !== 0"
                       @current-change="handleCurrentChange"
                       :current-page.sync="currentPage"
                       :page-size="15"
                       layout="total, prev, pager, next"
                       :total="total">
        </el-pagination>
        <create-update-resolution-code-category-dialog :categoryId="categoryToEdit" :visible="dialogVisible" @dialogClosed="editFinished" @save="appendCategory"></create-update-resolution-code-category-dialog>
    </div>
</template>

<script>
import CreateUpdateResolutionCodeCategoryDialog from "./CreateUpdateResolutionCodeCategoryDialog";
import { ProductSelector } from "@/app/shared/components";
import api from "../api";

export default {
    name: "resolution-code-category-list",
    components: {
        CreateUpdateResolutionCodeCategoryDialog,
        ProductSelector
    },
    data() {
        return {
            categories: [],
            loading: true,
            dialogVisible: false,
            categoryToEdit: null,
            filter: {
                productId: undefined,
                text: undefined
            },
            currentPage: 1,
            total: 0
        };
    },
    created() {
        this.loadCategories();
    },
    watch: {
        filter: {
            deep: true,
            handler: function(val) {
                this.loadCategories();
            }
        }
    },
    methods: {
        download() {
            api.downloadCategories(this.filter);
        },
        loadCategories() {
            this.loading = true;
            api.getCategories(
                this.currentPage,
                this.filter.productId,
                this.filter.text
            ).then(response => {
                this.loading = false;
                this.categories = response.data.items;
                this.total = response.data.total;
            });
        },
        appendCategory(event) {
            if (event.new) {
                this.categories.push(event.data);
                this.total += 1;
            } else {
                this.loadCategories();
            }
        },
        handleCurrentChange(page) {
            this.currentPage = page;
            this.loadCategories();
        },
        editCategory(id) {
            this.categoryToEdit = id;
            this.dialogVisible = true;
        },
        editFinished() {
            this.categoryToEdit = null;
            this.dialogVisible = false;
        },
        deleteCategory(id) {
            this.$confirm(this.$t('masters.thisWillDeleteCategoryContinue'), "Warning", {
                confirmButtonText: this.$t('common.OK'),
                cancelButtonText: this.$t('common.cancel'),
                type: "warning"
            }).then(() => {
                api.deleteCategory(id).then(() => {
                    this.loadCategories();
                    this.$message({
                        type: "success",
                        message: this.$t('common.deleteCompleted')
                    });
                });
            }).catch(_ => {});
        }
    }
};
</script>



// WEBPACK FOOTER //
// ClientApp/app/masters/resolutioncodes/components/ResolutionCodeCategoryList.vue